import { Languages } from './languages';
import automationEn from './locales/en/automation.json' with { type: 'json' };
import BargeControlEn from './locales/en/bargeControl.json' with { type: 'json' };
import cameraControlEn from './locales/en/cameraControl.json' with { type: 'json' };
import chartConfigEn from './locales/en/chartConfig.json' with { type: 'json' };
import CommonEn from './locales/en/common.json' with { type: 'json' };
import DeviceConfigEn from './locales/en/deviceConfig.json' with { type: 'json' };
import eventStreamEn from './locales/en/eventStream.json' with { type: 'json' };
import hybridPowerEn from './locales/en/hybridPower.json' with { type: 'json' };
import InventoryEn from './locales/en/inventory.json' with { type: 'json' };
import landingPageEn from './locales/en/landingPage.json' with { type: 'json' };
import networkHealthEn from './locales/en/networkHealth.json' with { type: 'json' };
import OpcUaServerEn from './locales/en/opcUaServer.json' with { type: 'json' };
import orbitOneEn from './locales/en/orbitOne.json' with { type: 'json' };
import penViewerEn from './locales/en/penViewer.json' with { type: 'json' };
import upCycleEn from './locales/en/upCycle.json' with { type: 'json' };
//Norwegian bokmål imports
import automationNo from './locales/nb/automation.json' with { type: 'json' };
import BargeControlNo from './locales/nb/bargeControl.json' with { type: 'json' };
import cameraControlNo from './locales/nb/cameraControl.json' with { type: 'json' };
import chartConfigNo from './locales/nb/chartConfig.json' with { type: 'json' };
import CommonNo from './locales/nb/common.json' with { type: 'json' };
import DeviceConfigNo from './locales/nb/deviceConfig.json' with { type: 'json' };
import eventStreamNo from './locales/nb/eventStream.json' with { type: 'json' };
import hybridPowerNo from './locales/nb/hybridPower.json' with { type: 'json' };
import InventoryNo from './locales/nb/inventory.json' with { type: 'json' };
import landingPageNo from './locales/nb/landingPage.json' with { type: 'json' };
import networkHealthNo from './locales/nb/networkHealth.json' with { type: 'json' };
import OpcUaServerNo from './locales/nb/opcUaServer.json' with { type: 'json' };
import orbitOneNo from './locales/nb/orbitOne.json' with { type: 'json' };
import penViewerNo from './locales/nb/penViewer.json' with { type: 'json' };
import upCycleNo from './locales/nb/upCycle.json' with { type: 'json' };

export const ApplicationLocalization = {
  automation: {
    [Languages.Norwegian]: automationNo,
    [Languages.English]: automationEn,
  },

  bargeControl: {
    [Languages.Norwegian]: BargeControlNo,
    [Languages.English]: BargeControlEn,
  },

  common: {
    [Languages.Norwegian]: CommonNo,
    [Languages.English]: CommonEn,
  },

  deviceConfig: {
    [Languages.Norwegian]: DeviceConfigNo,
    [Languages.English]: DeviceConfigEn,
  },

  eventStream: {
    [Languages.Norwegian]: eventStreamNo,
    [Languages.English]: eventStreamEn,
  },

  hybridPower: {
    [Languages.Norwegian]: hybridPowerNo,
    [Languages.English]: hybridPowerEn,
  },

  inventory: {
    [Languages.Norwegian]: InventoryNo,
    [Languages.English]: InventoryEn,
  },

  opcUaServer: {
    [Languages.Norwegian]: OpcUaServerNo,
    [Languages.English]: OpcUaServerEn,
  },

  upCycle: {
    [Languages.Norwegian]: upCycleNo,
    [Languages.English]: upCycleEn,
  },

  chartConfig: {
    [Languages.Norwegian]: chartConfigNo,
    [Languages.English]: chartConfigEn,
  },

  orbitOne: {
    [Languages.Norwegian]: orbitOneNo,
    [Languages.English]: orbitOneEn,
  },

  penViewer: {
    [Languages.Norwegian]: penViewerNo,
    [Languages.English]: penViewerEn,
  },
  cameraControl: {
    [Languages.Norwegian]: cameraControlNo,
    [Languages.English]: cameraControlEn,
  },
  landingPage: {
    [Languages.Norwegian]: landingPageNo,
    [Languages.English]: landingPageEn,
  },
  networkHealth: {
    [Languages.Norwegian]: networkHealthNo,
    [Languages.English]: networkHealthEn,
  },
};
